module.exports = __webpack_public_path__ + "static/new-planning-2-54dd1c311758ed0179535cf0b8db6da7.png";